import {
    PathSeparator,
    SearchTargetPathContainer,
} from 'components/global_search/styled';
import { HighlightedText } from 'components/text/HighlightedText';
import { memo } from 'react';

export type SearchTargetPathProps = Readonly<{
    entityName: string;
    entityPath: string[];
    remoteTokens: string[];
}>;

const separator = <PathSeparator>{'>'}</PathSeparator>;

function SearchTargetPath({
    entityPath,
    entityName,
    remoteTokens,
}: SearchTargetPathProps) {
    return (
        <SearchTargetPathContainer>
            {entityPath.length > 0 && (
                <>
                    {entityPath.reduce(
                        (parent, pathItem, index) => (
                            <>
                                {parent}
                                {index > 0 && separator}
                                {pathItem}
                            </>
                        ),
                        <></>
                    )}
                    {separator}
                </>
            )}
            <HighlightedText className="bold" text={entityName} terms={remoteTokens} />
        </SearchTargetPathContainer>
    );
}

const memoSearchTargetPath = memo(SearchTargetPath);
export { memoSearchTargetPath as SearchTargetPath };
